import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownWithoutOptionsProps } from "../models";
import { useQuery } from "@tanstack/react-query";

interface Props extends DropdownWithoutOptionsProps<server.dto.ContactSmallV2> {
  companyId: number
}

const ContactFromCompanyDropdown = (props: Props) => {
  const contactApi = useQuery({
    queryKey: ["contact", props.companyId],
    queryFn: async () => window.CoreApi.CompanyToContact.ListContactByCompany({ companyId: props.companyId, page: 1, perPage: 100 }).then(r => r.data.data.map(item => item.contact)),
    initialData: []
  });

  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    options={contactApi.data}
    getLabel={contact => contact.name.fullName}
    getValue={contact => contact.contactId}
    excludeKeys={props.excludeKeys}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default ContactFromCompanyDropdown;